import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { NavLink } from "react-router-dom";
import { Variables } from "../../Variations/Variations";
import { BiEdit, BiShowAlt, BiHide } from "react-icons/bi";
import { ToastContainer, toast } from "react-toastify";
import { AiOutlineClose, AiOutlineCheck, AiOutlineRight } from "react-icons/ai";

const AllContent = () => {
  const [rows, setRows] = useState([]); // [] so DataTable never gets undefined
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      name: "ID",
      selector: (row) => row.Id,
      sortable: true,
      width: "100px",
    },
    {
      name: "Title",
      selector: (row) => row.Title,
      sortable: true,
      wrap: true,
    },
    {
      name: "Widget Name",
      selector: (row) => row.Name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Image",
      selector: (row) => (
        <img
          alt="preview"
          src={Variables.API_PUBLISHED + row.Image}
          style={{ width: "100px", padding: "5px" }}
        />
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Published",
      sortable: true,
      center: true,
      width: "120px",
      cell: (row) =>
        row.IsPublished ? <AiOutlineCheck /> : <AiOutlineClose />,
    },
    {
      name: "Options",
      width: "200px",
      cell: (row) => (
        <div className="d-flex">
          <NavLink
            to={`/admin/rasha/content/${row.Id}`} // keep casing consistent everywhere
            className="btn btn-outline-secondary btn-sm"
          >
            <BiEdit />
          </NavLink>

          <button
            className="btn btn-outline-danger btn-sm ms-2"
            onClick={() => togglePublish(row.Id)}
            title={row.IsPublished ? "Unpublish" : "Publish"}
          >
            {row.IsPublished ? <BiHide /> : <BiShowAlt />}
          </button>
        </div>
      ),
    },
  ];

  async function togglePublish(id) {
    try {
      const res = await fetch(
        `${Variables.API_URL}Rasha/Content/UpsertPublish/${id}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      const msg = await res.json();
      if (!res.ok) {
        toast.error(typeof msg === "string" ? msg : "Failed to update");
        return;
      }

      toast.success(typeof msg === "string" ? msg : "Updated");
      // refresh
      await getContent();
    } catch (e) {
      toast.error("Network error while updating publish state");
    }
  }

  async function getContent() {
    setLoading(true);
    try {
      const res = await fetch(`${Variables.API_URL}Rasha/Content/Get`);
      if (!res.ok) throw new Error("Did not receive expected data");
      const listItems = await res.json();
      console.log(listItems);

      // FLATTEN: [{ Content, WidgetDetails }] -> [{ Id, Name, IsPublished, ... }]
      const flat = (listItems || []).map((x) => ({
        Id: x?.Content?.Id ?? 0,
        Title: x?.Content?.Title ?? "",
        Name: x?.WidgetDetails?.Name ?? "",
        IsPublished: !!x?.Content?.IsPublished,
        Image: x?.Content?.ImageUrl ?? "",
        _raw: x,
      }));

      setRows(flat);
    } catch (e) {
      toast.error("Failed to load content");
      setRows([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getContent();
  }, []);

  return (
    <div className="rightSide">
      <div className="container-fluid mt-3">
        <div className="row">
          <div className="col-12">
            <h2>List Contents</h2>
            <ul className="portalPath">
              <li>
                Home <AiOutlineRight />
              </li>
              <li>List Contents</li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="col-12 mb-3 text-end">
                  <NavLink
                    to="/admin/rasha/content/0"
                    className="btn btn-primary"
                  >
                    Add Content
                  </NavLink>
                </div>

                <div className="portalTable">
                  <DataTable
                    keyField="Id"
                    columns={columns}
                    data={rows}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                    dense
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
        />
      </div>
    </div>
  );
};

export default AllContent;
